import { createContext, useContext, useState } from "react";
import { clearAuth, getAuth, storeAuth } from "./authStorage";
import { MdErrorOutline } from "react-icons/md";
import { useToast } from "../../../components/controls/Toast/ToastService";
import { useNetwork } from "./useNetwork";
import useDeregisterPush from "../../push/useDeregisterPush";
import { Capacitor } from '@capacitor/core';

const authContext = createContext();
const useAuth = () => useContext(authContext)

const AuthProvider = ({ children }) => {
    const initiAuth = getAuth()
    const toast = useToast()
    const { setUnavailable } = useNetwork()
    const { handleDeregister } = useDeregisterPush();

    const initEmptyAuth = {
        isLogin: false,
        data: undefined,
        token: undefined,
    }
    const [authentication, setAuthentication] = useState(initiAuth ? initiAuth : initEmptyAuth)

    const logedIn = async (val, handleRegister) => {
         if (Capacitor.isNativePlatform()) {
            await handleRegister();
        }
        setAuthentication(val)
        storeAuth(val)
    }
    const logedOut = async () => {
        if (Capacitor.isNativePlatform()) {
            await handleDeregister();
        }
        setAuthentication(initEmptyAuth)
        clearAuth()
    }
    const axiosError = (err) => {
        if (err.status == 401) {
            logedOut()
            toast.open("Login Expired!", "text-red-400", <MdErrorOutline />);
        } else {
            setUnavailable()
            toast.open(err.message, "text-red-400", <MdErrorOutline />);
        }
    }
    return (
        <authContext.Provider value={{ logedIn, logedOut, axiosError, authentication }}>
            {children}
        </authContext.Provider>
    )
}

export default useAuth
export { AuthProvider }